// See https://date-fns.org/v4.1.0/docs/format for more details on formats
export const DATE_FORMAT_PATTERN = {
    DAY: "d", // 1
    DAY_MONTH: "do MMMM", // 1st January,
    SHORT: "dd/MM/yyyy", // 01/01/2020
    LONG: "d MMMM yyyy", // 1 January 2020
    LONG_SHORT: "d MMM yyyy", // 1 Jan 2020
    MONTH_YEAR: "MMMM yyyy", // January 2020,
    TIME: "HH:mm", // 12:00
}
